function getCreditsState(state) {
  return {
    fetchError: state.credits.fetchCreditsError,
    isInvalid: state.credits.isInvalid,
    loading: state.credits.loading,
    credits: state.credits.credits,
    hasGlobalCredits: state.credits.hasGlobalCredits,
    publicationPlans: state.credits.publicationPlans
  };
}

export { getCreditsState };
